import PageHero, { usePageTitle } from "@/components/PageHero";
import SectionHeader from "@/components/SectionHeader";
import MethodologySteps from "@/components/MethodologySteps";
import ValueDimensions from "@/components/ValueDimensions";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";

export default function Metodologia() {
  usePageTitle("Metodología BRIK | Un proceso probado para generar valor");
  return (
    <>
      <PageHero
        eyebrow="Metodología BRIK"
        titleLines={["Una metodología diseñada", "para generar valor."]}
        description="De la estrategia a la ejecución, con un enfoque práctico, medible y orientado a resultados."
        image="/brand/ref-boardroom-city.webp"
        alt="Metodología BRIK — strategic procurement en sala de juntas"
      />

      <section data-testid="methodology-deep" className="bg-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
          <SectionHeader
            eyebrow="El proceso"
            title="Seis pasos. Un sistema completo."
            description="Cada etapa construye sobre la anterior para transformar necesidades en capacidades, y capacidades en resultados."
          />
          <div className="mt-14">
            <MethodologySteps detailed />
          </div>
        </div>
      </section>

      <section data-testid="strategy-band" className="relative bg-oxford diagonal-lines overflow-hidden">
        <img src="/brand/isotipo-gold.webp" alt="" className="absolute -left-20 -top-20 w-80 opacity-[0.05] pointer-events-none" />
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24 text-center">
          <Reveal>
            <span className="inline-block h-px w-16 bg-gold mb-8" />
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-snug max-w-4xl mx-auto">
              De la estrategia a la ejecución.<br />
              <span className="text-gold">De la ejecución a un mayor impacto.</span>
            </p>
          </Reveal>
        </div>
      </section>

      <ValueDimensions />

      <CTABand
        title="Pongamos BRIK a trabajar para tu empresa."
        text="Cuéntanos tus necesidades. Diseñaremos una solución a la medida para fortalecer y transformar tu función de Compras."
        cta="Hablemos"
      />
    </>
  );
}
